import { useSelector } from "react-redux";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { selectUserData } from "../../../../features/userSlice";
import Page404 from "../../../../components/Page404/Page403";
import BrandConfigurationReport from "../../../../components/Partners/DataIntegrations/BrandConfigurationReport/BrandConfigurationReport";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { resetBrandConfigurationReportState } from "../../../../features/brandConfigurationReportSlice";

const BrandConfigurationReportScreen = () => {
  const userData = useSelector(selectUserData);
  const dispatch = useDispatch();
  const hasBrandConfigurationsReportPermission = CheckPermissions(
    userData?.data?.products?.partners,
    "data_intregrations",
    "view_brand_configurations"
  );

  //--Cleanup on unmount
  useEffect(() => {
    return () => {
      dispatch(resetBrandConfigurationReportState());
    };
  }, [dispatch]);

  return (
    <>
      {hasBrandConfigurationsReportPermission ? (
        <BrandConfigurationReport />
      ) : (
        <Page404 />
      )}
    </>
  );
};

export default BrandConfigurationReportScreen;
